/*
 * @Description: 
 * @Author:  
 * @Date: 2024-07-31 16:07:58
 * @LastEditTime: 2024-09-04 17:49:09
 * @LastEditors:  
 */

import axios from 'axios'
import md5 from 'md5'
import axios_req from '../axios'
import store from '../store'

function crc32(inputString) {
  var table = []
  for (var a = 0, b = 0; a < 256; a++) {
    b = a
    for (var c = 0; c < 8; c++) {
      b = (b & 1) ? (3988292384 ^ (b >>> 1)) : (b >>> 1)
    }
    table[a] = b
  }

  var crc = -1
  for (var i = 0; i < inputString.length; i++) {
    crc = (crc >>> 8) ^ table[(crc ^ inputString.charCodeAt(i)) & 0xFF]
  }

  return ((crc ^ (-1)) >>> 0)
}

let myticket = (data) => axios_req('post', '/api/ticket/myticket', data, 2)
let orderList = (data) => axios_req('post', '/api/order/list', data, 2)
let signdetail = (data) => axios_req('post', '/api/ticket/signdetail', data, 2)
let getMeta = (data) => axios_req('post', '/api/meta/getmeta', data, 2)
let getActExhibitionDetailInfo = (data) => axios_req('post', '/api/act/getActExhibitionDetailInfo', data, 2)
let getTicketList = (data) => axios_req('post', '/api/ticket/list', data, 2)
let vbefGenOrder = (data) => axios_req('post', '/api/order/vbefGenOrder', data, 2)
let getActExhibition = (data) => axios_req('post', '/api/act/getActExhibition', data, 2)
let getActExhibitionGuest = (data) => axios_req('post', '/api/act/getActExhibitionGuest', data, 2)
let detailcontent = (data) => axios_req('post', '/api/act/detailcontent', data, 2) //活动详情关联内容
let getMainPageContent = (data) => axios_req('post', '/api/act/getMainPageContent', data, 2) //展会内容配置
let getGuestDetail = (data) => axios_req('post', '/api/act/getGuestDetail', data, 2) //嘉宾基本信息
let getActAppMi = (data) => axios_req('post', '/api/act/getActAppMi', data, 2) //
let addCompEnrollment = (data) => axios_req('post', '/api/act/addCompEnrollment', data, 2) //
let submitFormdataForSelection = (data) => axios_req('post', '/api/act/SubmitFormdataForSelection', data, 2) //
let submitContribution = (data) => axios_req('post', '/api/act/submitContribution', data, 2) //
let getContributionList = (data) => axios_req('post', '/api/act/getContributionList', data, 2) //
let uploadContributionFile = async (file) => {
  const userAgent = navigator.userAgent
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)
  const timestampOrg = Math.trunc(new Date().getTime() / 1000)
  const timestampCrc = String(crc32(String(timestampOrg))).substring(0, 3)
  const timestamp = Number(timestampOrg + timestampCrc)
  const signParams = {
    uUid: store.state.uuid,
    uUserId: store.state.uuserId,
  }
  const headers = {
    'content-Type': 'multipart/form-data',
    userKey: store.state.user_key || '',
    timestamp,
    sign: md5(JSON.stringify(signParams) + timestamp),
    platform: isMobile ? 'vbefMobile' : 'vbefPC',
    vbBusinessId: '1',
    vbProjectId: '1',
    examineVersionNumber: '1',
    imei: store.state.uuid,
  }
  const formData = new FormData()
  formData.append('file', file)
  const response = await axios.post(store.state.req_url2 + '/api/user/file', formData, { headers })
  return response.data
}
let orderStatus = (data) => axios_req('post', '/api/order/orderStatus', data, 2) //
let genOpenidByWechatCode = (data) => axios_req('post', '/api/user/genOpenidByWechatCode', data, 2) //
let getPartnerList = (data) => axios_req('post', '/api/partner/list', data, 2) //同行人列表
let modifyPartner = (data) => axios_req('post', '/api/partner/modify', data, 2) //同行人列表
let delPartner = (data) => axios_req('post', '/api/partner/del', data, 2) //删除同行人
let addinvoice = (data) => axios_req('post', '/api/order/addinvoice', data, 2) //申请开发票
let ordercancel = (data) => axios_req('post', '/api/order/cancel', data, 2) //申请退款
let getAgendaList = (data) => axios_req('post', '/api/act/getAgendaList', data, 2) //议程列表
let checkIfThereAreSendTickets = (data) => axios_req('post', '/api/ticket/checkIfThereAreSendTickets', data, 2) //检查是否有赠送门票
let partnerTicket = (data) => axios_req('post', '/api/ticket/partnerTicket', data, 2) //检查是否有赠送门票
let acceptTicket = (data) => axios_req('post', '/api/ticket/acceptTicket', data, 2) //接受赠票
let sendTicketMsg = (data) => axios_req('post', '/api/ticket/sendTicketMsg', data, 2) //发送短信提醒
let getActivityChannel = (data) => axios_req('post', '/api/act/getActivityChannel', data, 2) //发送短信提醒
let editXuserChannel = (data) => axios_req('post', '/api/act/editXuserChannel', data, 2) //发送短信提醒
let findvbefticketbymobile = (data) => axios_req('post', '/api/writeoff/findvbefticketbymobile', data, 2) //电话号码查询VBEF门票
let writeoffvbeforder = (data) => axios_req('post', '/api/writeoff/writeoffvbeforder', data, 2) //核销VBEF门票
let csgctGenOrder = (data) => axios_req('post', '/api/order/csgctGenOrder', data, 2) //csgct提交订单信息
let getActExhibitionAllGuest = (data) => axios_req('post', '/api/act/getActExhibitionAllGuest', data, 2) //获取展会全部嘉宾列表
let paypalAddOrder = (data) => axios_req('post', '/api/paypal/addOrder', data, 2) //CSGCT外海订单表单提交
let paypalCheckoutOrder = (data) => axios_req('post', '/api/paypal/checkoutOrder', data, 2) //CSGCT外海订单表单提交
let getPaypalToken = (data) => axios_req('post', '/api/paypal/getPaypalToken', data, 2) //CSGCT外海订单表单提交
let getChannelById = (data) => axios_req('post', '/api/act/getChannelById', data, 2) //获取展会渠道信息
export  {
  myticket, orderList, signdetail, getMeta, getActExhibitionDetailInfo, getTicketList, vbefGenOrder, getActExhibition, detailcontent,
  getMainPageContent, getActExhibitionGuest, getGuestDetail, getActAppMi, addCompEnrollment, submitFormdataForSelection, submitContribution, getContributionList, uploadContributionFile, orderStatus, genOpenidByWechatCode, getPartnerList,
  modifyPartner, delPartner, addinvoice, ordercancel, getAgendaList, checkIfThereAreSendTickets, partnerTicket, acceptTicket, sendTicketMsg, getActivityChannel, editXuserChannel,
  findvbefticketbymobile, writeoffvbeforder, csgctGenOrder, getActExhibitionAllGuest,
  paypalAddOrder, paypalCheckoutOrder, getPaypalToken, getChannelById
}
